import NpsByDeviceTagChart from './NpsByDeviceTagChart';
export default NpsByDeviceTagChart;



// WEBPACK FOOTER //
// ./src/components/NpsByDeviceTagChart/index.js